
import { defineComponent } from 'vue'
import InstallAutofixMixin from '~/mixins/installAutofixMixin'

export default defineComponent({
  name: 'InstallAutofixModal',
  mixins: [InstallAutofixMixin]
})
